import React from "react";
import { AppBar, Typography } from "@mui/material";

const AlertBanner = ({ bannerHeight }) => {
  // Use env to handle text
  const bannerText = import.meta.env.VITE_BANNER_TEXT || "";

  return (
    <AppBar
      position="static"
      color="default"
      sx={{
        height: bannerHeight ? `${bannerHeight}px` : "35px",
        alignItems: "center",
      }}
    >
      <Typography variant="subtitle1" sx={{ flexGrow: 1, mt: "4px" }}>
        {bannerText}
      </Typography>
    </AppBar>
  );
};

export default AlertBanner;
